import React from 'react'
import '../styles/form-input.styles.scss'

const FormInput = ({ handleOnChange, label, search, clearInput, ...otherProps }) => {

  if (search) {
    return (
      <div className='group'>
        <input className='form-input' onChange={handleOnChange} {...otherProps} />
        <span className="clear-input" onClick={clearInput}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg></span>
      </div>
    )
  }

  return (
    <div className='group'>
      <input className='form-input' onChange={handleOnChange} {...otherProps} />
      {label ?
        <label
          className={`${otherProps.value.length ? 'shrink' : ''} form-input-label`}
        >
          {label}
        </label> : null
      }
    </div>
  )
}

export default FormInput